import { faqs, offer, stats } from './content'
import type { FaqItem, Stat } from './content'

export const kitHero = {
  subheadline: '100 vizuálních map + 6 profesionálních sad připravených k použití',
  description:
    '100 hotových vysvětlení pro klienty, 24 tréninků k úpravě a 50 chyb s praktickými korekcemi. Vše přehledně – méně improvizace, více jistoty.',
}

export const kitStats: Stat[] = stats.map((stat) =>
  stat.label === 'Praktických bonusů' ? { ...stat, label: 'Profesionálních sad' } : stat,
)

export interface Kit {
  number: string
  title: string
  hook: string
  description: string
}

export const kitsCopy = {
  title: 'A to není všechno: dostaneš i 6 profesionálních sad připravených k použití.',
  subtitle:
    'Nejen mapy na prohlížení. Šest praktických nástrojů, se kterými vysvětlíš cviky, připravíš tréninky a uspořádáš práci s klienty.',
  badge: 'V balíčku',
  closing:
    'Od vysvětlení cviku po první trénink s novým klientem: šest nástrojů pro práci s větším pořádkem a menší improvizací.',
  closingNote: 'Všech 6 sad je součástí kompletního balíčku.',
}

export const kits: Kit[] = [
  {
    number: '01',
    title: '100 hotových vysvětlení pro klienty',
    hook: 'Správná slova pro vysvětlení každého cviku.',
    description:
      '100 přehledných vysvětlení: zapojené svaly, technika a praktické tipy. Otevři kartu a přizpůsob ji klientovi.',
  },
  {
    number: '02',
    title: 'Matice náhradních cviků',
    hook: 'Najdi správnou náhradu, aniž bys začínal od nuly.',
    description:
      'Hotová matice variant seřazených podle pohybového vzoru, úrovně a dostupného vybavení.',
  },
  {
    number: '03',
    title: '24 tréninků k úpravě',
    hook: 'Konec začínání s prázdným papírem.',
    description:
      '24 karet s cviky, sériemi, opakováními a hotovým pořadím. Vyber trénink a přizpůsob ho klientovi.',
  },
  {
    number: '04',
    title: 'Rychlé korekce: 50 nejčastějších chyb',
    hook: 'Poznáš chybu. Víš, na co se dívat a co opravit.',
    description:
      '50 častých technických chyb s praktickými tipy, díky kterým korekci vysvětlíš jasněji.',
  },
  {
    number: '05',
    title: 'Karty klienta a sledování pokroku',
    hook: 'Méně volných papírů. Větší kontrola nad pokrokem.',
    description:
      'Hotové šablony pro zápis tréninků, vah, opakování a pokroku tvých klientů.',
  },
  {
    number: '06',
    title: 'První trénink bez improvizace',
    hook: 'První schůzka – už naplánovaná.',
    description:
      'Checklist, karta cílů a struktura první schůzky, abys nové klienty přijímal s větší jistotou.',
  },
]

export interface KitOfferRow {
  title: string
  detail: string
}

export const kitOffer = {
  label: 'Kompletní balíček pro osobního trenéra',
  name: 'Vizuální atlas biomechaniky cviků',
  summary: '100 vizuálních map + 6 profesionálních sad',
  status: 'V balíčku',
  bundle: '1 kompletní atlas + 6 profesionálních sad',
  bundleNote: 'Vše přehledně. Jeden nákup. Bez předplatného.',
  priceLabel: 'Celý systém jen za',
  price: offer.price,
  currency: offer.currency,
  priceNote: 'Jednorázová platba. Přístup navždy.',
  cta: 'Ano, chci celý systém',
  note: 'Bezpečná platba · Okamžité stažení · Záruka 7 dní',
  closing:
    '100 analyzovaných cviků a 6 nástrojů připravených k práci. Vše v jednom digitálním balíčku.',
}

export const kitOfferRows: KitOfferRow[] = [
  {
    title: 'Vizuální atlas – 100 map cviků',
    detail: 'Svaly, technika, anatomické roviny, časté chyby a varianty.',
  },
  {
    title: 'Sada: vysvětlení a náhradní cviky',
    detail: '100 hotových vysvětlení + matice náhradních cviků.',
  },
  {
    title: 'Sada: tréninky a korekce',
    detail: '24 tréninků k úpravě + 50 technických chyb s praktickými tipy.',
  },
  {
    title: 'Sada: klienti a první trénink',
    detail: 'Karty pro sledování pokroku + nástroje pro naplánování první schůzky.',
  },
  {
    title: 'Plný digitální přístup',
    detail: 'PDF k tisku · Okamžitý přístup · Přístup navždy.',
  },
]

export const kitFinalCta = {
  title: '100 analyzovaných cviků. 6 hotových sad. Jeden systém.',
  subtitle:
    'Všechny informace a nástroje, které potřebuješ k vysvětlování cviků, přípravě tréninků a organizaci práce s klienty – v jednom balíčku.',
  summary: '100 vizuálních map + 6 profesionálních sad',
  cta: 'Chci celý systém',
}

export const kitFaqs: FaqItem[] = faqs.map((faq) =>
  faq.question === 'Obsahuje hotové tréninkové plány?'
    ? {
        question: 'Obsahuje hotové tréninky?',
        answer:
          'Ano. V sadě najdeš 24 přehledných tréninků, které můžeš použít jako výchozí bod a přizpůsobit každému klientovi. Nejsou to personalizované plány a nenahrazují tvé odborné posouzení.',
      }
    : faq,
)
